export default function NoPage() {
    return (
        <h2>404 not found</h2>
    );
}